// @flow

import { type IdentityVerificationStatus } from 'Containers/ModalManager/modals/SelfieVerification/constants';
import { SELFIE_CHALLENGE_REQUIRED_STATUSES } from 'Containers/SelfieChallenge/constants';

/**
 * isSelfieChallengeRequired determines whether the user should be selfie challenged
 * @param { IdentityVerificationStatus } status - Selfie verification status from meta or updates payload
 * @return { boolean } isSelfieChallenged
 */
const isSelfieChallengeRequired = (status: IdentityVerificationStatus): boolean =>
  SELFIE_CHALLENGE_REQUIRED_STATUSES.includes(status);

export default isSelfieChallengeRequired;
